import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Guides.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function GuidesDownload() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      // Redirect to actual download
      window.location.href = `${API_URL}/guides/download/${token}`;
    }
  }, [token, navigate]);

  return (
    <div className="guides-page">
      <Helmet>
        <title>Downloading Guide | PrivateSold</title>
      </Helmet>
      
      <div className="guides-success container">
        <div className="success-card">
          <div className="loading-spinner"></div>
          <h1>Preparing Your Download...</h1>
          <p>Your PDF will begin downloading automatically.</p>
          <p className="help-text">
            If the download doesn't start, <a href={`${API_URL}/guides/download/${token}`}>click here</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default GuidesDownload;
